import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';

import Header from './Header';
import Messages from './Messages';
import TextBox from './TextBox';
import MessageLoading from './MessageLoading';
import globalVars from '../../../../utils/globalVars';
import { DispatchEvent } from '../../../../utils/dispatchEvent';
import { useWhiteLabel } from '../../../../hooks/useWhiteLabel';

import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../store/modules/chat/actions';
import { CustomerHasPaymentIntegratorProvider } from '../contexts/customerHasPaymentIntegrator/provider';
import { CustomerChannelBalanceProvider } from '../contexts/customerChannelBalance/provider';

import { DropzoneUploader } from '../../../dropzone/v2';
import { useFlags } from 'flagsmith/react';
import { customUseFlags } from 'src/hooks/customUseFlags';
import { TextAreaProvider } from '../contexts/textArea/provider';
import { CopilotAnswerProvider } from '../contexts/copilotAnswer/context';
import { ImproveAnswerProvider } from '../contexts/improveAnswer/context';

var content;
var messagesRender;

function Chat({
  chat,
  dateConnectedSocket,
  messagesLoaded,
  isLoadingMessagesOneChat,
  settings,
  chatDropzone,
  fetchMessagesRequest,
  oneChatLoaded,
  idSelectedChat,
  fetchShoppingCartDetail,
}) {
  const whitelabel = useWhiteLabel();
  const [isWindow24Open, setIsWindow24Open] = useState(false);
  const [blockInteraction, setBlockInteraction] = useState(false);
  const flag = useFlags(['ia_suggestion']);
  const ia_suggestion = customUseFlags(flag.ia_suggestion);

  useEffect(() => {
    if (chat.contact.shopping_cart_current) {
      fetchShoppingCartDetail(chat.contact.shopping_cart_current.id);
    }
  }, [chat.contact]);

  /**
   * Quando fica offline e a plataforma volta a ficar online devemos buscar novamente as mensagens
   */
  const [offline, setOffline] = useState(false);

  window.addEventListener('online', () => {
    if (offline) setOffline(false);
  });

  window.addEventListener('offline', () => {
    if (!offline) setOffline(true);
  });

  useEffect(() => {
    if (!offline && chat.loadMessages) {
      fetchMessagesRequest(chat.id, true);
    }
  }, [offline, dateConnectedSocket]);
  /* end */

  useEffect(() => {
    if (whitelabel.scriptInjection !== '') {
      //criação de variável global para ser usada em scripts injetados
      if (chat.view?.selectedChannel) {
        globalVars.setChannel({
          id: chat.view?.selectedChannel?.id,
          name: chat.view?.selectedChannel?.channel_name,
          uid: chat.view?.selectedChannel?.channel_uid,
          type: chat.view?.selectedChannel?.type,
        });
      } else {
        globalVars.setChannel({ id: chat.chat.channel_id });
      }
      DispatchEvent('change_channel', window.Poli?.channel);
    }
  }, [chat.chat.channel_id, whitelabel.scriptInjection]);
  /**
   * Se não foi carregada as mensagens ainda
   */
  useEffect(() => {
    if (!chat.loadMessages) {
      const offLoading = true;
      fetchMessagesRequest(chat.id, offLoading);
    } else {
      oneChatLoaded();
      idSelectedChat(chat.id);
    }
  }, [chat.loadMessages, chat.id]);

  useEffect(() => {
    if (chat.contact && whitelabel.scriptInjection !== '') {
      //criação de variável global para ser usada em scripts injetados
      globalVars.setContact(chat.contact);
      DispatchEvent('change_contact', window.Poli?.contact);
    }
  }, [chat.id]);

  /**
   * Hook renderizar componente mensagem
   */
  useMemo(() => {
    messagesRender = <MessageLoading />;
    if (messagesLoaded && !isLoadingMessagesOneChat) {
      messagesRender = <Messages />;
    }
  }, [messagesLoaded && !isLoadingMessagesOneChat]);

  /**
   * Hook montar chat completo
   */
  useMemo(() => {
    let isChatDropzone = chatDropzone;
    if (isChatDropzone) {
      isChatDropzone = settings.can_send_file;
    }

    content = (
      <div className="realChatContainer">
        <Header blockInteraction={blockInteraction} />
        {isChatDropzone && <DropzoneUploader />}
        {!isChatDropzone && messagesRender}

        {
          <div
            style={{
              display: !isChatDropzone ? 'block' : 'none',
              position: 'relative',
              backgroundColor: 'var(--background-messages)',
            }}
          >
            <TextBox
              // TODO: refatorar a abordagem de verificação de janela de 24h
              isEnabledByUserSettings={settings.enable_reply_suggestion_ai}
              blockInteraction={blockInteraction}
              setBlockInteraction={setBlockInteraction}
              onrender={(value) => {
                setIsWindow24Open(value);
              }}
            />
          </div>
        }
      </div>
    );
  }, [
    blockInteraction,
    chatDropzone,
    settings.can_send_file,
    messagesRender,
    isWindow24Open,
    ia_suggestion,
  ]);

  return (
    <TextAreaProvider>
      <CopilotAnswerProvider
        isEnabledByUserSettings={settings.enable_reply_suggestion_ai}
      >
        <ImproveAnswerProvider>
          <CustomerChannelBalanceProvider
            contactId={chat.id}
            channelCustomerId={chat?.view?.selectedChannel?.id}
          >
            <CustomerHasPaymentIntegratorProvider
              customer_id={settings.customer_id}
            >
              {content}
            </CustomerHasPaymentIntegratorProvider>
          </CustomerChannelBalanceProvider>
        </ImproveAnswerProvider>
      </CopilotAnswerProvider>
    </TextAreaProvider>
  );
}
const mapStateToProps = (state) => ({
  dateConnectedSocket: state?.chat?.socket?.dateConnected,
  chat: state.chat?.chats?.find((chat) => chat.open === true),
  isLoadingMessagesOneChat: state.chat.loadingMessagesOneChat,
  messagesLoaded: state.chat.messagesLoaded,
  settings: state.chat?.config?.general?.settings,
  chatDropzone: state.chat.chats?.find(
    (chat) => chat.id === state.chat.chatSelectedId
  )?.chatDropzone,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
